import React, { memo, useEffect, useState } from "react";
import { NodeResizer, useReactFlow } from "@xyflow/react";

const RulerNode = ({ data, id, selected }: any) => {
  const { setNodes } = useReactFlow();

  const [width, setWidth] = useState(data.width || 200);
  const [height, setHeight] = useState(data.height || 50);
  const [orientation, setOrientation] = useState(
    data.orientation || "vertical"
  );
  const values = data.rulerVariables || [];

  const handleResize = (
    event: any,
    size: { width: number; height: number }
  ) => {
    setOrientation(size.width > size.height ? "horizontal" : "vertical");
    setWidth(size.width);
    setHeight(size.height);
    setNodes((nodes) =>
      nodes.map((node) =>
        node.id === id
          ? {
              ...node,
              data: {
                ...node.data,
                width: size.width,
                height: size.height,
              },
            }
          : node
      )
    );
  };

  const formatValue = (value: any) => {
    if (typeof value === "number") {
      return value.toFixed(2);
    }
    return value;
  };

  const renderValues = () => {
    const keys = [];
    for (const obj of values) {
      const leitura = data?.leitura || {};
      if (leitura?.variaveis) {
        leitura.variaveis.forEach((element: any) => {
          if (element[obj.key]) {
            leitura[obj.key] = element[obj.key];
          }
        });
      }
      let valor = {
        key: obj.name,
        value: leitura[obj.key] || "-",
      };
      keys.push(valor);
    }
    return keys.map((value: any, index: number) => (
      <div
        key={index}
        style={{
          padding: "2px",
          textAlign: "center",
          // borderBottom:
          //   orientation === "horizontal" ? "none" : "1px solid #ccc",
          // borderRight: orientation === "horizontal" ? "1px solid #ccc" : "none",
          fontSize: data.fontSize || 12,
        }}
      >
        {value.key}: {formatValue(value.value)}
      </div>
    ));
  };

  return (
    <div
      style={{
        position: "relative",
        width: `${width}px`,
        height: `auto`,
        display: "flex",
        flexDirection: orientation === "horizontal" ? "row" : "column",
        backgroundColor: "rgba(0, 119, 255, 0.1)",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
      }}
    >
      <NodeResizer
        color="#0077ff"
        isVisible={selected}
        minWidth={25}
        minHeight={25}
        onResize={handleResize}
      />

      <div
        style={{
          display: "flex",
          flexDirection: orientation === "horizontal" ? "row" : "column",
          justifyContent: "space-between",
          width: "100%",
          height: "100%",
        }}
      >
        {renderValues()}
      </div>
    </div>
  );
};

export default RulerNode;
